module.exports = __webpack_public_path__ + "img/fontawesome-webfont.c1e38fd.svg";